import React from "react";
import {
  Col,
  Form,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";

// Image
import { BaseButton, BaseInput } from "Components/ui";
import Select from "react-select";
import { useFormik } from "formik";
import { CategoryValidationSchema } from "utils";
import { useCreateCategory } from "hooks/useCategories";

const options = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
];

const AddCategoryModal = (props?: any) => {
  const { isOpen, toggle } = props;
  const { mutate, isPending } = useCreateCategory();

  const formik = useFormik({
    initialValues: {
      name: "",
      description: "",
      status: options[0].value, // Initially empty, this will be set by react-select
    },
    validationSchema: CategoryValidationSchema,
    onSubmit: (values) => {
      mutate(
        { name: values.name, description: values.description },
        {
          onSuccess: () => {
            formik.resetForm();
            toggle();
          },
        }
      );
    },
  });

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={true}>
      <ModalHeader toggle={toggle} tag="h4">
        Add Category
      </ModalHeader>
      <ModalBody>
        <Form onSubmit={formik.handleSubmit}>
          <Row>
            <Col xs={12}>
              <div className="mb-3">
                <BaseInput
                  label="Name"
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={formik.touched.name && !!formik.errors.name}
                  errorMessage={formik.errors.name}
                />
              </div>
              <div className="mb-3">
                <BaseInput
                  label="Description"
                  name="description"
                  type="textarea"
                  value={formik.values.description}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  invalid={
                    formik.touched.description && !!formik.errors.description
                  }
                  errorMessage={formik.errors.description}
                />
              </div>
              <div className="mb-3 pb-4">
                <Label> Status </Label>
                <Select
                  name="category"
                  options={options}
                  defaultValue={options[0]}
                  classNamePrefix="select2-selection"
                  value={options.find(
                    (option) => option.value === formik.values.status
                  )}
                  onChange={(option: any) =>
                    formik.setFieldValue("status", option.value)
                  }
                  onBlur={() => formik.setFieldTouched("status")}
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="text-end">
                <BaseButton
                  load
                  type="submit"
                  color="success"
                  className="save-customer"
                  loading={isPending}
                >
                  Add Category
                </BaseButton>
              </div>
            </Col>
          </Row>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default AddCategoryModal;
